import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Logo from "../assets/logo.png";
import Logout from "../assets/logout.svg";
import Toolbar from "@material-ui/core/Toolbar";
import Fade from '@material-ui/core/Fade';
import HeaderStyle from "../styles/HeaderStyle";
import { Avatar } from "@material-ui/core";


function Header(props) {
    const { classes, login, selectedPrescriberInfo = {}, callStarted } = props;
    const avatarText = login ? Object.keys(selectedPrescriberInfo).length !== 0 ? `${selectedPrescriberInfo['FirstName'][0]}${selectedPrescriberInfo['LastName'][0]}` : "" : "";
    const [anchorEl, setAnchorEl] = React.useState(false);

    const handleClick = (event) => {
        if (callStarted) {
            return;
        }
        setAnchorEl(true);
    };
    const handleClose = () => {
        setAnchorEl(false);
    };

    const logout = () => {
        let { LogOff } = props;
        LogOff && LogOff();
        window.open(process.env.REACT_APP_LOGOUT_URL, "_self");
    };

    return (
        <Toolbar className={classes.headerContainer + " " + classes.dFlex} data-app="headerContainer" data-view="headerContainer">
            <div className={classes.alignItemsCenter}>
                <div className='flex'>
                    <img id='page-title-logo' className='height-30' src={Logo} alt='logo' />
                </div>
            </div>
            {login && <div className={`${classes.dFlex} ${classes.logoutModal}`}>
                <div className={classes.avatarWrapper}>
                    <label id="prescriber-welcome-name" className={classes.welcomeText + " " + classes.alignItemsCenter}>{selectedPrescriberInfo.Message} </label>
                    <Avatar id="avatar" className={`${classes.avatar} ${classes.floatRight} ${callStarted ? classes.disabledHeader : ""}`} onClick={_ => !anchorEl && handleClick()} onMouseEnter={handleClick} >{avatarText}</Avatar>
                    {anchorEl ?
                        <Fade in={anchorEl}>
                            <div id="avatar-menu" onClick={handleClose} className={classes.modalBackdrop}>
                                <div style={{ top: 0 }} className={classes.modalWrapper}>
                                    <div id="avatar-logout-wrapper" className={classes.menuWrapper} onClick={logout}>
                                        <div className={classes.menuText}>Logout</div>
                                        <img className={classes.menuIcon} src={Logout} alt="logout" />
                                    </div>
                                </div>
                            </div>
                        </Fade> : null}
                </div>
            </div>}
        </Toolbar>
    );
}

export default withStyles(HeaderStyle)(Header);